var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.27 136.54C105.974 136.54 136.54 105.974 136.54 68.27C136.54 30.5655 105.974 0 68.27 0C30.5655 0 0 30.5655 0 68.27C0 105.974 30.5655 136.54 68.27 136.54Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9403 35.9805H51.7803V100.89H100.63V35.9805H97.9403ZM97.9403 98.1605H54.4703V38.6705H97.9403V98.1605Z",
    fill: "#572580"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 52.3906H58.3799V54.1706H93.1399V52.3906Z",
    fill: "#572580"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 55.75H58.3799V57.53H93.1399V55.75Z",
    fill: "#572580"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 59.1094H58.3799V60.8894H93.1399V59.1094Z",
    fill: "#572580"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 62.4707H58.3799V64.2507H93.1399V62.4707Z",
    fill: "#572580"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 65.8301H58.3799V67.6101H93.1399V65.8301Z",
    fill: "#572580"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 69.1797H58.3799V70.9597H93.1399V69.1797Z",
    fill: "#572580"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 72.5391H58.3799V74.3191H93.1399V72.5391Z",
    fill: "#572580"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 75.9004H58.3799V77.6804H93.1399V75.9004Z",
    fill: "#572580"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 79.2598H58.3799V81.0398H93.1399V79.2598Z",
    fill: "#572580"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 82.6191H58.3799V84.3991H93.1399V82.6191Z",
    fill: "#572580"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 85.9805H58.3799V87.7605H93.1399V85.9805Z",
    fill: "#572580"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 89.3301H58.3799V91.1101H93.1399V89.3301Z",
    fill: "#572580"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1399 92.6895H58.3799V94.4695H93.1399V92.6895Z",
    fill: "#572580"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0199 43.5098H58.3799V46.1998H72.0199V43.5098Z",
    fill: "#F6E71C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7499 46.8301H58.3799V49.5201H81.7499V46.8301Z",
    fill: "#F6E71C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1104 95.4409V37.6309H46.2104V95.4409",
    fill: "#F6E71C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5595 95.4391H44.8695V38.9791H42.4595V95.4391H39.7695V36.2891H47.5595V95.4391Z",
    fill: "#572580"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4302 71.4492H41.4902V74.1392H46.4302V71.4492Z",
    fill: "#572580"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4302 67.5801H41.4902V70.2701H46.4302V67.5801Z",
    fill: "#572580"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4898 60.8402H35.7998V40.6602H47.0598V43.3502H38.4898V60.8402Z",
    fill: "#572580"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2104 96.1095V95.5195H41.1104V96.1095V96.7795L42.3904 101.32H44.9403L46.2104 96.7795V96.1095Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9595 102.66H41.3695L39.7695 96.9699V94.1699H47.5595V96.9699L45.9595 102.66ZM43.3695 99.9699H43.8795L44.7595 96.8599H42.5395L43.3695 99.9699Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.738957e021877b40a2c6c9922abe6edb.svg";
export { ForwardRef as ReactComponent };